import type { Feature } from '@luna/gatekeeper';

export const cardServices: Feature = {
    enabled: true,
    _description: 'Displays additional card services in the credit card settings page',
};
